import React from "react";
import { Input } from "antd";
import type { InputProps } from "antd";

interface TypePhoneNumberProps extends InputProps {}

export function fixPhoneInput(input: string | undefined): string {
  if (!input) return "";

  // 只取数字
  const digits = input.replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 3) {
    return `(${digits}`;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
}

/**
 * @name PhoneNumber 联系电话
 * @description 转换成美国的电话格式
 */
const PhoneNumber: React.FC<TypePhoneNumberProps> = ({
  value,
  onChange,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.({
      ...e,
      target: {
        ...e.target,
        value: fixPhoneInput(e.target.value),
      },
    });
  };

  return (
    <Input
      size="large"
      value={fixPhoneInput(value as string)}
      onChange={handleChange}
      {...props}
    />
  );
};

export default PhoneNumber;
